import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';

import config from './client/config';

const { cdn, REACT_APP_BUILDTIME } = window.__TBX_ENV__;
const isProduction = process.env.NODE_ENV === 'production';

const options = {
  backend: {
    loadPath: `${cdn.baseURL}/${config.clientShortName}/locales/crm/{{lng}}.json`,
    // allow cross domain requests
    crossDomain: false,
    // allow credentials on cross domain requests
    withCredentials: false,
    // overrideMimeType sets request.overrideMimeType("application/json")
    overrideMimeType: false,
    // custom request headers sets request.setRequestHeader(key, value)
    // can also be a function, that returns the headers
    customHeaders: () => ({
      // ...
    }),
    // adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
    queryStringParams: { b: REACT_APP_BUILDTIME },
    // reloadInterval: // can be used to reload resources in a specific interval (milliseconds) (useful in server environments)
  },
  debug: !isProduction,
  fallbackLng: 'es',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
    // format: (value, format, lng) => { // legacy usage
    //   if (value instanceof Date) {
    //     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
    //   }
    //   return value;
    // }
  },
  // allow keys to be phrases having `:`, `.`
  nsSeparator: undefined,
  keySeparator: undefined,
  react: {
    useSuspense: false
  }
};

i18n
.use(HttpBackend)
.use(initReactI18next)
.init<HttpBackendOptions>(options);

export default i18n;
